var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5"},[_c('i',{staticClass:"fas fa-spinner fa-spin mr-2"}),_vm._v("Please wait...")])}]

export { render, staticRenderFns }